export const BANK_STATUS_OPTIONS = [
  { value: 'new', text: 'New' },
  { value: 'pending_unreachable', text: 'Unreachable' },
  { value: 'pending_docs', text: 'Pending Docs' },
  { value: 'pending_docs_submitted', text: 'Docs Submitted' },
  { value: 'pending_reappealed', text: 'Loan Re-appealed' },
  { value: 'pending_meeting', text: 'Pending Meeting' },
  { value: 'meeting_completed', text: 'Meeting Completed' },
  { value: 'reject_bank', text: 'Loan Rejected' },
  { value: 'reject_customer', text: 'Customer Rejected' },
  { value: 'reject_cancelled', text: 'Cancelled' },
  { value: 'reject_developer', text: 'Cancelled by Developer' },
  { value: 'approved_lo_issued', text: 'LO Issued' },
  { value: 'success_li_issued', text: 'LO Signed' },
  { value: 'archived', text: 'Archived' },
  { value: 'reject_unqualified', text: 'Unqualified' },
  { value: 'reject_lo_signed_other_bank', text: 'LO Signed with another bank' },
  { value: 'reject_wrong_info', text: 'Wrong Info' },
];

export const STAGE_STATUS_OPTIONS = [
  { value: 'new', text: 'New' },
  { value: 'follow_up', text: 'Follow-up' },
  { value: 'reserved', text: 'Reserved' },
  { value: 'booked', text: 'Booked' },
  { value: 'won', text: 'Won' },
  { value: 'lost', text: 'Lost' },
];

export const BANK_STATUS_MAP = BANK_STATUS_OPTIONS.reduce(
  (acc, tab) => ({
    ...acc,
    [tab.value]: tab,
  }),
  {},
);

export const STAGE_STATUS_MAP = STAGE_STATUS_OPTIONS.reduce(
  (acc, option) => ({
    ...acc,
    [option.value]: option,
  }),
  {},
);



// WEBPACK FOOTER //
// ./src/constants/bankStatesAndOppStage.js